import { Box } from "@chakra-ui/react";
import { BaseStack, GoiBaseModal, ColorIcon } from "goi_common";
import { baseColors } from "goi_common/src/design-system";

// 실제 상담 발신번호(010)의 뒷자리만 노출해 수신율을 높인다
const CONSULT_PHONE = "010-****-9784";

interface ConsultCompleteModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function ConsultCompleteModal({
  isOpen,
  onClose,
}: ConsultCompleteModalProps) {
  return (
    <GoiBaseModal
      isOpen={isOpen}
      onClose={onClose}
      showCloseButton={false}
      closeOnOverlayClick={false}
      header={
        <BaseStack alignItems="center" spacing={8}>
          <ColorIcon name="icon_Graphic_CS" size={56} />
          <Box
            className="headline_1_sb"
            textAlign="center"
            color={baseColors.label_normal}
          >
            상담 신청이 완료되었어요
          </Box>
          <Box
            width="100%"
            bg={baseColors.fill_normal}
            borderRadius="6px"
            height="56px"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Box
              className="body_1_normal_sb"
              color={baseColors.blue_400}
              textAlign="center"
            >
              {CONSULT_PHONE}
            </Box>
          </Box>
          <Box
            className="body_2_normal_r"
            color={baseColors.gray_700}
            textAlign="center"
            style={{ whiteSpace: "pre-line" }}
          >
            {
              "상담사가 위 번호로 전화드릴 예정이에요.\n뒷자리를 확인하시고 꼭 받아주세요."
            }
          </Box>
        </BaseStack>
      }
      footer={
        <GoiBaseModal.Footer
          primaryButton={{ text: "확인", onClick: onClose }}
        />
      }
    />
  );
}
